import { BascQueryProvider, setGatewayUrl } from '@bco/ui';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@bco/ui-theme/styles.css';
import App from './App';
import { RootErrorBoundary } from './components/RootErrorBoundary';
import './index.css';

// Configure API gateway URL for @bco/ui library
setGatewayUrl(import.meta.env.VITE_GATEWAY_URL || '');

// Note: BascProvider is now handled by ClientThemeProvider in App.tsx
// to support dynamic client-specific themes
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RootErrorBoundary>
      <BascQueryProvider>
        <BrowserRouter
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          <App />
        </BrowserRouter>
      </BascQueryProvider>
    </RootErrorBoundary>
  </React.StrictMode>
);
